import { isProblemError } from '@volee/api-client'
import { isLocalAuthRefusal } from '@volee/auth'
import { QueryClient } from '@tanstack/react-query'

// The TanStack Query client (docs/design/frontend-v1.md §4.4): the cache of server data, the
// current user and their roles included. None of it is duplicated in a store.

/** A 4xx is an answer, not a failure: retrying it does not change the outcome. Nor does a
 *  refusal `@volee/auth` raised without making a request — a missing scope stays missing. */
function shouldRetry(attempts: number, error: unknown): boolean {
  if (isProblemError(error) && error.status >= 400 && error.status < 500) {
    return false
  }
  if (isLocalAuthRefusal(error)) return false
  return attempts < 2
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: shouldRetry,
        staleTime: 30 * 1000,
        // A refetch on every window focus is traffic spent on data that changes in
        // minutes, not in seconds.
        refetchOnWindowFocus: false,
      },
      mutations: {
        // A mutation is not idempotent: retrying it can duplicate a write.
        retry: false,
      },
    },
  })
}
